import React, { useMemo } from 'react';
import { FlatList, Text, useWindowDimensions, View } from 'react-native';
import { getCleanUrl } from '../../utils/Helper';
import CustomPressable from '../customPressable/customPressable';
import { ImageComp } from '../Image/Image';
import { CHEVRON_RIGHT } from '../../assets';
import { useCssStyle } from '../../customHook/getCssStyle';
import RenderHTML from 'react-native-render-html';

const getCustomComponent = (widgetType) => {
  // Use require at call-time to avoid circular import with getWidget.js
  const { widgetDisplayType } = require('./getWidget');
  const match = widgetDisplayType.find(w => w.type === widgetType);
  return match ? match.CompName : null;
};

const BannerMultipleWidget = props => {
  const { listItemData, displayName, handleOnWidgetClick, widget } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()


  const renderItem = (item, index) => {
    const CustomComp = getCustomComponent(item?.widgetType);
    if (CustomComp) {
      return (
        <CustomComp
          key={item.id}
          widget={item}
          listItemData={item.subWidgetMap}
          handleOnWidgetClick={handleOnWidgetClick}
        />
      );
    }

    const isLastItem = index === listItemData.length - 1;

    return (
      <CustomPressable 
        onPress={() => handleOnWidgetClick(item)} 
        style={getStyles([
          'bannerWidgetsMultipleWidgetContainer', 
          isLastItem ? { borderBottomWidth: 0, paddingBottom: 0 } : {},
          `bannerWidgetsMultipleWidgetContainer_${item.widgetMetaHtmlId}` ,
          `bannerWidgetsMultipleWidgetContainer_${item.id}`
        ])} 
        id={`bannerWidgetsMultipleWidgetContainer bannerWidgetsMultipleWidgetContainer_${item.widgetMetaHtmlId} bannerWidgetsMultipleWidgetContainer_${item.id}`}
      >

        <>
          <View style={getStyles(['bannerWidgetMultipleImageStyle', `bannerWidgetMultipleImageStyle_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleImageStyle_${item.id}`])} id={`bannerWidgetMultipleImageStyle bannerWidgetMultipleImageStyle_${item.widgetMetaHtmlId} bannerWidgetMultipleImageStyle_${item.id}`}>
              <ImageComp
                source={getCleanUrl(item?.btnImageUrl)}
                style={getStyles(['bannerWidgetMultipleImage', 'bannerWidgetMultipleImage', `bannerWidgetMultipleImage_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleImage_${item.id}`])}
                id={`bannerWidgetMultipleImage bannerWidgetMultipleImage_${item.widgetMetaHtmlId} bannerWidgetMultipleImage_${item.id}`}
              />
          </View>

          <View 
            style={getStyles(['bannerWidgetMultipleTextContainer', `bannerWidgetMultipleTextContainer_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleTextContainer_${item.id}`])} 
            id={`bannerWidgetMultipleTextContainer bannerWidgetMultipleTextContainer_${item.widgetMetaHtmlId} bannerWidgetMultipleTextContainer_${item.id}`}
          >
            {item?.widgetTitle && <Text 
              style={getStyles(['bannerWidgetMultipleTitle', `bannerWidgetMultipleTitle_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleTitle_${item.id}`])} 
              numberOfLines={2} 
              id={`bannerWidgetMultipleTitle bannerWidgetMultipleTitle_${item.widgetMetaHtmlId} bannerWidgetMultipleTitle_${item.id}`} 
            >
              {item?.widgetTitle}
            </Text>}

            {item?.widgetDesc && <Text 
              style={getStyles(['bannerWidgetMultipleDescription', `bannerWidgetMultipleDescription_${item.bannerWidgetTitle}`, `bannerWidgetMultipleDescription_${item.id}`])} 
              id={`bannerWidgetMultipleDescription bannerWidgetMultipleDescription_${item.bannerWidgetTitle} bannerWidgetMultipleDescription_${item.id}`} 
              numberOfLines={2}
            >
              {item?.widgetDesc}
            </Text>}
          </View>

          <View 
            style={getStyles(['bannerWidgetMultipleArrow_container', `bannerWidgetMultipleArrow_container_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleArrow_container_${item.id}`])} 
            id={`bannerWidgetMultipleArrow_container bannerWidgetMultipleArrow_container_${item.widgetMetaHtmlId} bannerWidgetMultipleArrow_container_${item.id}`}
          >
            <ImageComp source={CHEVRON_RIGHT} style={getStyles(['bannerWidgetMultipleArrow', `bannerWidgetMultipleArrow_${item.widgetMetaHtmlId}`, `bannerWidgetMultipleArrow_${item.id}`])} id={`bannerWidgetMultipleArrow bannerWidgetMultipleArrow_${item.widgetMetaHtmlId} bannerWidgetMultipleArrow_${item.id}`} />
          </View>
        </>
      </CustomPressable>
    );
  };

  const customWidgetTitleStyle = useMemo(() => {
      const style = getStyles(["bannerMultipleMultipleWidgetTitleText"])
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
  
      // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);
    
    const customWidgetDescriptioneStyle = useMemo(() => {
      const style = getStyles(["bannerMultipleMultipleWidgetDescriptionText"])
      return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
  
      // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

  return (
    <View 
      style={getStyles(['bannerWidgetMultipleMainContainer', `bannerWidgetMultipleMainContainer_${listItemData[0].widgetMetaHtmlId}`, `bannerWidgetMultipleMainContainer_${listItemData[0].id}`])} 
      id={`bannerWidgetMultipleMainContainer bannerWidgetMultipleMainContainer_${listItemData[0].widgetMetaHtmlId} bannerWidgetMultipleMainContainer_${listItemData[0].id}`}
    >
      <View style={getStyles(["bannerMultipleMultipleWidgetTitleContainer"])} id={`bannerMultipleMultipleWidgetTitleContainer`} >
        <View style={getStyles(["bannerMultipleMultipleWidgetTitleTextContainer"])} id={`bannerMultipleMultipleWidgetTitleTextContainer`}>
          {widget?.displayName && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetTitleStyle}
              source={{ html: widget?.displayName}}
              systemFonts={[customWidgetTitleStyle.fontFamily]}
              id={`bannerMultipleMultipleWidgetTitleText`}
          />}
          {widget?.widgetDesc && <RenderHTML
              contentWidth={width}
              baseStyle={customWidgetDescriptioneStyle}
              source={{ html: widget?.widgetDesc}}
              systemFonts={[customWidgetDescriptioneStyle.fontFamily]}
              id={`bannerMultipleMultipleWidgetDescriptionText`}
          />}
        </View>
    </View>
      {listItemData?.map((item, index) => renderItem(item, index))}
    </View>
  );
};

export default React.memo(BannerMultipleWidget);
